import { render, staticRenderFns } from "./Overviews.vue?vue&type=template&id=d19dd48e&scoped=true"
import script from "./Overviews.vue?vue&type=script&lang=js"
export * from "./Overviews.vue?vue&type=script&lang=js"
import style0 from "./Overviews.vue?vue&type=style&index=0&id=d19dd48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19dd48e",
  null
  
)

export default component.exports